module.exports = __webpack_public_path__ + "img/5.52db5190.png";